import { Hero } from "@/components/home/Hero";
import { Featured } from "@/components/home/Featured";
import { Cheesecakes } from "@/components/home/Cheesecakes";
import { AboutTeaser } from "@/components/home/AboutTeaser";
import { CustomTeaser } from "@/components/home/CustomTeaser";
import { Testimonials } from "@/components/home/Testimonials";
import { InstaGallery } from "@/components/home/InstaGallery";
import { FinalCta } from "@/components/home/FinalCta";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Featured />
      <Cheesecakes />
      <AboutTeaser />
      <CustomTeaser />
      <Testimonials />
      <InstaGallery />
      <FinalCta />
    </main>
  );
}
